// Helpers for parsing the CookieYes cookie

import { useCookie } from 'nuxt/app'

export namespace CookieYes {
    const CookieName = 'cookieyes-consent'
    export const ConsentUpdateEvent = 'cookieyes_consent_update'

    // anchor elements with this class name will trigger the preference change dialog
    // https://www.cookieyes.com/documentation/change-cookie-consent-using-cookieyes/
    export const ConsentUpdateClass = 'cky-banner-element'

    interface ConsentUpdateDetail {
        accepted: Category[]
        rejected: Category[]
    }

    export interface ConsentUpdate {
        detail: ConsentUpdateDetail
    }

    // CookieYes is automatically injected into the site via Google Tag Manager

    // Note that it is explicitly configured to be injected on jackboxgames.com,
    // and you **cannot** test it on localhost (or jackbox.studio)
    // https://www.cookieyes.com/documentation/use-localhost-to-test-cookieyes/

    // You can, however, manually add a cookie to localhost in your browser, using the same data shape

    // the CookieYes cookie looks like this:
    // ---------------------- key -----------------------
    // cookieyes-consent
    // --------------------- value ----------------------
    // consentid:AAAbBbb0b0bBBBcCCCcccCCcDddDD11eeeEEeee2FFf,consent:no,action:yes,
    // necessary:yes,functional:no,analytics:yes,performance:no,advertisement:no,other:no
    // --------------------------------------------------

    export enum Category {
        Consent = 'consent', // General Cookie consent yes-no
        Action = 'action', // User has interacted with cookie banner

        // All other specific categories below:
        Necessary = 'necessary',
        Functional = 'functional',
        Analytics = 'analytics',
        Performance = 'performance',
        Advertisement = 'advertisement',
        Other = 'other'
    }

    const getCookieYesCookie = () => {
        const cookie = useCookie(CookieName)
        return cookie.value || null
    }

    export function hasConsent(category: Category): boolean {
        // Default to consent opt-in for development environments only
        if (process.env.NODE_ENV === 'development') {
            return true
        }

        const unparsedConsentData = getCookieYesCookie()
        if (!unparsedConsentData) {
            return false
        }
        const data = unparsedConsentData.split(',')
        for (let i = 0; i < data.length; i++) {
            const cookieInfo = data[i].split(':')
            const key = cookieInfo[0] || null
            const val = cookieInfo[1] || null
            if (key === category as string) {
                return val === 'yes'
            }
        }

        return false
    }
}
